import { combineReducers } from '@reduxjs/toolkit';
import { reducer as calendarReducer } from 'slices/calendar';
import { reducer as mailboxReducer } from 'slices/mailbox';
import { reducer as projectsBoardReducer } from 'slices/projects_board';
import parametersReducer from 'store/ducks/Parameters';

const rootReducer = combineReducers({
  calendar: calendarReducer,
  projectsBoard: projectsBoardReducer,
  mailbox: mailboxReducer,
  parameters: parametersReducer,
});

export default rootReducer;
